import React from 'react';
import PropTypes from 'prop-types';

const Strings = require("../../../../app/shared/Strings");

const propTypes = {
    backHandler: PropTypes.func.isRequired,
};

const defaultProps = {};

function BackButton(props) {
    return (
        <div className="sub-nav-button-container">
            <button
                className="bare-text-button"
                aria-label={Strings['en'].navigation.GO_BACK}
                onClick={props.backHandler}
            >
                <span className="fa fa-chevron-left" aria-hidden/>
            </button>
        </div>
    );
}

BackButton.propTypes = propTypes;
BackButton.defaultProps = defaultProps;

export default BackButton;